import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { config } from "../../services/configHeader";

const baseUrl = process.env.REACT_APP_BASE_URI;

let initialState = {
    dailyAttLoading: false,
    dailyAttSuccess: false,
    dailyAttError: false,
    dailyAttMessage: null,

    dailyAttGetLoading: false,
    dailyAttGetSuccess: false,
    dailyAttGetError: false,
    dailyAttGetMessage: null,
    dailyAttGetData: null,
};

const user = localStorage.getItem("user_data")
    ? JSON.parse(localStorage.getItem("user_data"))
    : null;
const userId = user?.user_id;
const accountType = user?.account_type;

export const fetchDailyAttData = createAsyncThunk("fetchDailyAttData", async (body) => {
    const { path, data } = body
    return await axios
        .post(`${baseUrl}${path}`, data, config)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            if (!navigator.onLine) {
                let data = {
                    response: {
                        data: [],
                        message: "No Internet Connection Found",
                        success: false,
                    },
                    data: {
                        data: [],
                        message: "No Internet Connection Found",
                        success: false,
                    },
                }
                return data
            } else {
                return error
            }

        });
});

export const saveDailyAtt = createAsyncThunk("saveDailyAtt", async (data) => {
    const result = {
        data: {
            message: "Sorry, you can only view the data, not create it.",
            data: [],
        },
    };

    return parseInt(accountType) === 2
        ? result
        : await axios
            .post(`${baseUrl}admin/createBranch`, data, config)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                if (!navigator.onLine) {
                    alert('You are offline. Please check your internet connection.');
                } else {
                    alert('An error occurred. Please try again later.');
                }
                let data = {
                    response: {
                        data: [],
                        message: "No Internet Connection Found",
                        success: false
                    },
                }
                return data
            });
});

const dailyAttendanceSlice = createSlice({
    name: "dailyAttendance",
    initialState,

    reducers: {
        initDailyState: (state) => {
            state.dailyAttLoading = false;
            state.dailyAttSuccess = false;
            state.dailyAttError = false;
            state.dailyAttMessage = null;
        },
        initDailyAttState: (state) => {
            state.dailyAttGetLoading = false;
            state.dailyAttGetSuccess = false;
            state.dailyAttGetError = false;
            state.dailyAttGetMessage = null;
        },
    },

    extraReducers: (builder) => {
        builder.addCase(fetchDailyAttData.pending, (state, action) => {
            state.dailyAttGetLoading = true;
            state.dailyAttGetSuccess = false;
            state.dailyAttGetError = false;
            state.dailyAttGetMessage = null;
            state.dailyAttGetData = null;
        });
        builder.addCase(fetchDailyAttData.fulfilled, (state, action) => {
            state.dailyAttGetLoading = false;
            state.dailyAttGetSuccess = true;
            state.dailyAttGetError = false;
            state.dailyAttGetMessage = action.payload.data.message;
            state.dailyAttGetData = action.payload.data;
        });
        builder.addCase(fetchDailyAttData.rejected, (state, action) => {
            state.dailyAttGetLoading = false;
            state.dailyAttGetSuccess = false;
            state.dailyAttGetError = true;
            state.dailyAttGetMessage = action.payload.data.message;
            state.dailyAttGetData = null;
        });
        // To create branch
        builder.addCase(saveDailyAtt.pending, (state, action) => {
            state.dailyAttLoading = true;
            state.dailyAttSuccess = false;
            state.dailyAttError = false;
            state.dailyAttMessage = null;
        });
        builder.addCase(saveDailyAtt.fulfilled, (state, action) => {
            state.dailyAttLoading = false;
            state.dailyAttSuccess = accountType == 2 ? false : true;
            state.dailyAttError = accountType == 2 ? true : false;
            state.dailyAttMessage = action.payload.data.message;
        });
        builder.addCase(saveDailyAtt.rejected, (state, action) => {
            state.dailyAttLoading = false;
            state.dailyAttSuccess = false;
            state.dailyAttError = true;
            state.dailyAttMessage = action.payload.data.message;
        });
    },
});

export const { initDailyState, initDailyAttState } = dailyAttendanceSlice.actions;

export default dailyAttendanceSlice.reducer;
